import { getPeriodDates } from "components/SelectDateTimePeriod";
import { TemplateType } from "../../SearchTemplateProvider";

/**
 * Fixing period date values in the stored form state
 */
const loadPeriodValue = (value) => {
    if (
        value &&
        typeof value === "object" &&
        value.period &&
        value.period !== "custom" &&
        ((Object.keys(value).length === 3 && value.start && value.end) ||
            Object.keys(value).length === 1)
    ) {
        return { ...value, ...getPeriodDates(value.period) };
    }

    return value;
};

/**
 * Fix orderIndex property in RealTimeMonitor resultTableConfig columns
 * The filed with orderIndex=1 value has to be "__check__" column or free.
 * Otherwise the row selection checkbox column won't be on the first place of column list
 * (It is needed in RTM templates only, because currently it is the only one datagrid, which
 * uses row selection. The newly saved templates will be stored with proper orderIndexValue.)
 */
const fixOrderIndexInRtmGridConfig = (template, resultTableConfig) => {
    if (
        template.type === TemplateType.REAL_TIME_MONITOR &&
        resultTableConfig &&
        resultTableConfig.columns.find(({ orderIndex }) => orderIndex === 1)
            .field !== "__check__"
    ) {
        return {
            ...resultTableConfig,
            columns: resultTableConfig.columns.map((column) => {
                return {
                    ...column,
                    orderIndex:
                        column.orderIndex > 0
                            ? column.orderIndex + 1
                            : column.orderIndex,
                };
            }),
        };
    }

    return resultTableConfig;
};

/**
 * Make changes and overrides in template content before it is loaded
 * @param {object} template
 * @return {object}
 */
export default (template) => {
    const templateContent = JSON.parse(template.content);

    const searchFormState = Object.entries(
        templateContent.searchFormState
    ).reduce(
        (prevValue, [key, value]) => ({
            ...prevValue,
            [key]: loadPeriodValue(value),
        }),
        {}
    );

    templateContent.resultTableConfig = fixOrderIndexInRtmGridConfig(
        template,
        templateContent.resultTableConfig
    );

    return {
        ...template,
        content: JSON.stringify({ ...templateContent, searchFormState }),
    };
};
